import React from 'react'
import {View} from 'react-native'
export function BlurView (props:any){
    return <div pointerEvents={props.poineterEvents}  style={{...props.style,  
        filter: 'blur(8px)' ,
    WebkitFilter: 'blur(8px)' ,
    backdropFilter:'blur(8px)',

}} />
}